var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivePriceStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM11.916 4.7774C12.0692 4.54764 12.0071 4.2372 11.7774 4.08403C11.5476 3.93085 11.2372 3.99294 11.084 4.2227L7.39698 9.75321L4.3254 7.12042C4.11574 6.94071 3.80009 6.96499 3.62038 7.17466C3.44067 7.38432 3.46495 7.69997 3.67461 7.87968L7.17461 10.8797C7.28326 10.9728 7.42659 11.0149 7.56834 10.9954C7.71008 10.9758 7.83666 10.8965 7.91603 10.7774L11.916 4.7774Z",
    fill: "#499C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePriceStatusIcon);
export default __webpack_public_path__ + "static/media/activePriceStatusIcon.52421f49.svg";
export { ForwardRef as ReactComponent };